// define a mixin object
import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';

export const companyMixins = {
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState('my-company', {
            isSavePending: 'isPatchPending'
        }),
        ...mapGetters('my-company', {
            getFromStore: 'get'
        }),
        company() {
            return this.getFromStore("mine") || {};
        },

    },
    created: function () {
        // this.getMyCompany("mine");
    },
    methods: {
        ...mapActions('my-company', {
            updateCompany: 'patch',
            getMyCompany: 'get',
            createCompany: 'create',
            // saveCompany: 'save'

        }),
        saveCompany({ noToast = false } = { noToast: false }) {
            let promise;
            if (this.company._id)
                promise = this.updateCompany([this.company._id, this.company, {}]);
            else {
                promise = this.createCompany(this.company);
            }

            return promise.then(result => {
                if (noToast)
                    return;
                this.$toasted.global.success({
                    message: this.$t('Changes saved')
                });
                setTimeout( () => {
                    location.reload();
                }, 500);
            }).catch(error => {
                if (noToast)
                    return;
                this.$toasted.global.error({
                    message: this.$t('Error while saving') + error.message,
                });
            })

        },

    }
}
